export const VINCULO_OPCOES = [
  { value: 'proprio', label: 'Próprio atleta', desc: 'Conta pertence ao próprio atleta — só permitido para maiores de 18 anos.' },
  { value: 'responsavel', label: 'Responsável legal', desc: 'Pai, mãe ou tutor(a) do atleta.' },
  { value: 'professor', label: 'Professor(a) / técnico(a)', desc: 'Conta de quem treina ou representa o atleta.' },
];

export function calcularIdade(dataNascimento) {
  if (!dataNascimento) return null;
  const hoje = new Date();
  const nasc = new Date(`${dataNascimento}T00:00:00`);
  if (Number.isNaN(nasc.getTime())) return null;
  let idade = hoje.getFullYear() - nasc.getFullYear();
  const aindaNaoFezAniversario =
    hoje.getMonth() < nasc.getMonth() ||
    (hoje.getMonth() === nasc.getMonth() && hoje.getDate() < nasc.getDate());
  if (aindaNaoFezAniversario) idade--;
  return idade;
}

export function erroVinculoIdade(vinculo, dataNascimento) {
  if (vinculo !== 'proprio') return '';
  if (!dataNascimento) return 'Informe a data de nascimento.';
  const idade = calcularIdade(dataNascimento);
  if (idade === null) return 'Data de nascimento inválida.';
  if (idade < 18) {
    return 'Vínculo "próprio" exige 18 anos ou mais. Use "responsável legal" ou "professor(a)" para atletas menores de idade.';
  }
  return '';
}

export function montarFormDataAtleta(campos, fotoFile) {
  const fd = new FormData();
  Object.entries(campos).forEach(([chave, valor]) => {
    if (valor !== null && valor !== undefined) fd.append(chave, valor);
  });
  if (fotoFile) fd.append('foto', fotoFile);
  return fd;
}
